import React, { Component } from 'react';

import Membership from './Membership/Membership';
import Benefits from './Benefits/Benefits';
import Options from './Options/Options';
import ReadyToJoin from './ReadyToJoin/ReadyToJoin';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';

import Helmet from 'react-helmet';
import BenefitsContentDesktop from './Options/BenefitsContent/Desktop/Desktop';
import BenefitsContentMobile from './Options/BenefitsContent/Mobile/Mobile';

class SuiteKey extends Component {
  state = {
    modalActive: false
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current
    });
  };

  render() {
    let height = window.innerHeight;

    const membershipProps = {
      id: 'suite-key-membership',
      screenHeight: height,
      className: 'panel d-flex align-items-center',
      header: 'SuiteKey Membership',
      subHeader: 'High flyers welcome',
      content:
        'SuiteKey memberships unlock elite access to the best of JetSuite, with premium experiences, preferred' +
        ' access to aircraft,  exclusive rates, friendly, dedicated guest services and individualized benefits.' +
        ' Our expansive fleet of jets offers the comfort and efficiency you expect from private aviation, and our' +
        ' friendly, gracious staff provide you with the elevated cabin experience you deserve. Plus, you’ll be' +
        ' welcomed into our global community of like-hearted private travelers.',
      style: {
        width: this.props.heightSm ? '750px' : '510px'
      }
    };

    const benefitsProps = {
      id: 'suite-key-benefits',
      screenHeight: height,
      className: 'panel d-flex align-items-center',
      mainContent: {
        id: 0,
        header: 'Membership Benefits',
        content:
          'Members are entitled to a premium rarified air experience, dedicated guest services, in-flight culinary delights, on-board amenities, members-only gifts, and preferred access to our hotel, helicopter, luxury car and other partners.'
      },
      boxs: [
        {
          id: 1,
          title: 'Enjoy a Fixed Hourly Rate',
          header: '',
          content: ''
        },
        {
          id: 2,
          title: '365 Day Access',
          header: '',
          content: ''
        },
        {
          id: 3,
          title: 'Exclusive All-Embraer Fleet',
          header: '',
          content: ''
        },
        {
          id: 4,
          title: 'Unique Preferred Partners and Events',
          header: '',
          content: ''
        },
        {
          id: 5,
          title: 'No Repositioning Fees',
          header: '',
          content: ''
        },
        {
          id: 6,
          title: 'Guaranteed availability with 48-hours notice',
          header: '',
          content: ''
        }
      ]
    };

    const optionsProps = {
      id: 'suite-key-options',
      screenHeight: height,
      className: 'panel d-flex align-items-center',
      header: 'Membership Options',
      content: BenefitsContentMobile,
      modalContent: BenefitsContentDesktop,
      button: {
        classNames: 'btn btn-default btn-block mt-3 d-none d-md-block',
        click: this.toggleModal,
        label: 'Membership Level Benefits'
      }
    };

    const readyToJoinProps = {
      screenHeight: height,
      className:
        window.location.pathname === '/suitekey-membership/join'
          ? 'panel align-items-center'
          : 'panel d-none align-items-center'
    };

    const scrollContainerProps = {
      pageHeight: height,
      active: window.location.pathname === '/suitekey-membership/join' ? 3 : 0
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>SuiteKey Membership | JetSuite</title>
          <meta
            name="description"
            content={
              'SuiteKey memberships unlock elite access to the best of JetSuite, with premium experiences, preferred access to aircraft, exclusive rates, friendly, dedicated guest services and individualized benefits.'
            }
          />
        </Helmet>

        <ScrollContainer {...scrollContainerProps}>
          <Membership {...membershipProps} />
          <Benefits {...benefitsProps} heightSm={this.props.heightSm} />
          <Options
            {...optionsProps}
            {...this.state}
            toggleModal={() => this.toggleModal()}
          />
          {window.innerWidth > 991 && <ReadyToJoin {...readyToJoinProps} />}
        </ScrollContainer>
      </React.Fragment>
    );
  }
}

export default SuiteKey;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/SuiteKey.js